import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";

function TextMaskInput(props) {
  const { inputRef, mask, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      guide={false}
      mask={mask}
      placeholderChar={"\u2000"}
    />
  );
}
TextMaskInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default TextMaskInput;



// WEBPACK FOOTER //
// ./src/components/Forms/TextMaskInput.jsx